import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioHttp from '../servicios/ServicioHttp';
import servicioFormatos from '../servicios/ServicioFormatos';

export class CorrecionFacturasPeaje extends Component {
    constructor() {
        super();
        this.state = {
            errores: {},
            cfdi: {},
            cfdis: {}
        };

    }

    buscar = () => {
        let { cfdi }=this.state;
        servicioHttp.consumirPostHttp('/cfdi/buscar_por_uuid.json',cfdi).then(response => {
            this.setState({cfdis:response.data.lista});
        }).catch(error => {

        });
    }

    asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);
    }

    templateColumnaFechaCreacion = (rowData, column) => {
        return servicioFormatos.formatearFechaYYYYMMDDHHmmss(rowData.fechaCreacion);
    }

    templateColumnaFechaCertificacion = (rowData, column) => {
        return servicioFormatos.formatearFechaYYYYMMDDHHmmss(rowData.fechaCertificacion);
    }

    templateColumnaFechaCancelacion = (rowData, column) => {
        return servicioFormatos.formatearFechaYYYYMMDDHHmmss(rowData.fechaCancelacion);
    }

    templateColumnaTotal = (rowData, column) => {
        return servicioFormatos.formatearModena(rowData.total);
    }

    templateColumnaEstado = (rowData, column) => {        
        return servicioFormatos.formatoEstadoCfdi(rowData.estado);              
    }

    templateCancelar = (rowData, column) => {
        if(rowData.estado===1){
            return <Button icon="pi-md-close"/>
        }else{
            return null;
        }
    }

    templateReexpedir = (rowData, column) =>{
        if(rowData.estado===2){
            return <Button icon="pi-md-check"/>
        }else{
            return null;
        }
    }

    render() {

        let { errores, cfdi, cfdis } = this.state;
        return (
            <div className="p-fluid">
                <div className="card">
                    <div className="p-grid">
                        <div className="p-col-12">
                            <h1>Corrección de facturas de peaje</h1>
                            <p>En este módulo se pueden corregir las facturas erroneas</p>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="p-grid">
                        <div className="p-col-12 p-md-8">
                            <span className="md-inputfield">
                                <InputText className={errores.uuid ? "p-error" : ""} type="search" id="cfdi.uuid" name="cfdi.uuid" value={cfdi.uuid || ''} onChange={this.asignarValoresObjeto}></InputText>
                                <label>* Uuid:</label>
                                {errores.uuid ? <div> <Message severity="error" text={errores.uuid} /> </div> : null}
                            </span>
                        </div>
                        <div className="p-col-12 p-md-2">
                            <Button label="Buscar" icon="pi-md-search" className="p-button-success" onClick={this.buscar} />
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="p-grid">
                        <div className="p-col-12">
                            <DataTable value={cfdis} header="Cfdi" responsive={true} resizableColumns={true}>
                                <Column body={this.templateCancelar} header="Cancelar" />
                                <Column body={this.templateReexpedir} header="Reexpedir" />
                                <Column field="uuid" header="Uuid" autoLayout={true} resizableColumns={true} />
                                <Column field="serie" header="Serie" autoLayout={true} resizableColumns={true} />
                                <Column field="folio" header="Folio" autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateColumnaFechaCreacion} header="Fecha Creación" autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateColumnaFechaCertificacion} header="Fecha Certificación" autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateColumnaFechaCancelacion} header="Fecha Cancelación" autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateColumnaTotal} header="Total" autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateColumnaEstado} header="Estado" autoLayout={true} resizableColumns={true} />
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}